module.exports = __webpack_public_path__ + "img/back-hands.079d5f5b.svg";